import { Injectable, inject } from '@angular/core';
import { LoginModalContent } from '../../../models/aem';
import { WifiPortalService } from '../../../services/wifi-portal/wifi-portal.service';

@Injectable({
  providedIn: 'root'
})
export class UnlockYourAccountAdapterService {
  wifiPortalService = inject(WifiPortalService);

  getUnlockYourAccountScreenContent(loginModalContent: LoginModalContent) {
    const { unlockAccount, pageHeader } = loginModalContent;
    const pageHeaderObj = {
      logoUrl: pageHeader.logoUrl,
      altText: pageHeader.altText
    };

    return {
      unlockYourAccountView: {
        ...pageHeaderObj,
        ...unlockAccount,
        wifiPortal: this.wifiPortalService.getQueryParamsWFP().isWFP
      }
    };
  }
}
